module.exports = __webpack_public_path__ + "static/media/rock1.d19238d6.mp3";